import React from 'react';
import {connect} from 'react-redux';
import root from 'window-or-global';
import styles from './SignUpSuccessSection.pcss';
import {Button, Message, buttonTypes, getMessage, RedirectWithParams} from 'epic-diesel-common';
import {priority} from 'epic-diesel-common/src/constants';
import {generateRoutePath} from 'epic-common/src/route';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import Url from '../../../constants/Url';
import axios from 'axios';
import {FormsyForm, LoadIndicator} from '../..';
import Textarea from 'epic-diesel-form/src/components/form/Textarea';
import classNames from 'classnames';

const RATING_TYPES = {
    BAD: 0,
    GOOD: 1
};

class SignUpSuccessSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object.isRequired,
        accountId: PropTypes.string.isRequired,
        isLoggedIn: PropTypes.bool.isRequired,
        history: PropTypes.object.isRequired,
        isAffiliateSubmit: PropTypes.bool
    };

    static defaultProps = {
        isAffiliateSubmit: false
    };

    constructor(props) {
        super(props);
        this.state = {
            rating: null,
            comment: '',
            loading: false,
            successSubmit: null
        };
    }

    componentDidMount() {
        // a quick hack to fire a success pageView pixel without breaking too many things
        if (root.history && typeof root.history.pushState) {
            root.history.pushState(null, '', generateRoutePath('/signup/success'));
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.props.isLoggedIn) {
            this.props.history.push(generateRoutePath('/affiliate/overview'));
        }
    }

    handleRatingSet(rating) {
        this.setState({rating});
    }

    handleChangeMessage(event) {
        this.setState({comment: event.currentTarget.value});
    }

    handleSubmitSurvey = async () => {
        const {rating, comment} = this.state;

        if (rating !== null) {
            this.setState({loading: true});
            try {
                await axios.post(`${Url().CREATE_SURVEY}`, {
                    accountId: this.props.accountId,
                    comment: comment.trim(),
                    rating
                });

                this.setState({
                    loading: false,
                    successSubmit: true
                });
            } catch (error) {
                console.error(error);
                this.setState({
                    loading: false,
                    successSubmit: false
                });
            } finally {
                this.props.history.push(generateRoutePath('dashboard'));
            }
        }
    };

    renderRatingButton(ratingType) {
        return (
            <Button
                priority={priority.PRIMARY}
                theme="dark"
                type="button"
                hasHover={false}
                hasMinWidth={false}
                className={classNames(
                    styles['rating_button'],
                    ratingType === RATING_TYPES.GOOD && styles['rating_button--good'],
                    ratingType === RATING_TYPES.BAD && styles['rating_button--bad'],
                    ratingType === this.state.rating && styles['rating_button--active']
                )}
                onClick={() =>
                    this.state.rating !== ratingType && this.handleRatingSet(ratingType)
                }>
                &nbsp;
            </Button>
        );
    }

    render() {
        const {isAffiliateSubmit} = this.props;
        if (!isAffiliateSubmit) {
            return <RedirectWithParams to="overview" />;
        }

        const {loading, comment, rating} = this.state;

        const commentPlaceholder = getMessage(
            this.props.messages,
            'epic.affiliate.signup.success.survey.comment'
        );

        return (
            <div className={styles.container}>
                <LoadIndicator isLoading={loading}>
                    <div className={styles.survey}>
                        <div className={styles.survey_block}>
                            <h2 className={styles.survey_title}>
                                <Message code="epic.affiliate.signup.success.topTitle" />
                            </h2>
                            <p className={styles.survey_text}>
                                <Message code="epic.affiliate.signup.success.topText" />
                            </p>
                        </div>
                        <div className={styles.survey_block}>
                            <h2 className={styles.survey_title}>
                                <Message code="epic.affiliate.signup.success.survey.title" />
                            </h2>
                            <p className={styles.survey_text}>
                                <Message code="epic.affiliate.signup.success.survey.text" />
                            </p>
                        </div>
                        <FormsyForm submitForm={() => this.handleSubmitSurvey()}>
                            <div className={classNames(styles.survey_rating, styles.survey_block)}>
                                {this.renderRatingButton(RATING_TYPES.GOOD)}
                                {this.renderRatingButton(RATING_TYPES.BAD)}
                            </div>
                            <div
                                className={classNames(styles.survey_textarea, styles.survey_block)}>
                                <Textarea
                                    value={comment}
                                    placeholder={commentPlaceholder}
                                    onChange={event => this.handleChangeMessage(event)}
                                    name="comment"
                                />
                            </div>
                            <div className={styles.survey_actions}>
                                <Button
                                    className={styles.action_button}
                                    useClassName
                                    priority={priority.SECONDARY}
                                    to={generateRoutePath('dashboard')}
                                    isExternalUrl={false}>
                                    <Message code="epic.affiliate.common.cancel" />
                                </Button>
                                <Button
                                    className={styles.action_button}
                                    useClassName
                                    priority={priority.PRIMARY}
                                    theme="dark"
                                    type={buttonTypes.SUBMIT}
                                    disabled={rating === null}>
                                    <Message code="epic.affiliate.signup.success.survey.submit" />
                                </Button>
                            </div>
                        </FormsyForm>
                    </div>
                </LoadIndicator>
            </div>
        );
    }
}

export default withRouter(connect()(SignUpSuccessSection));
